import React, { useState } from 'react';
import { SolutionSearchQuery } from '../services/DataService';

interface SolutionSearchFormProps {
  onSearch: (query: SolutionSearchQuery) => void;
  isLoading: boolean;
}

const SolutionSearchForm: React.FC<SolutionSearchFormProps> = ({
  onSearch,
  isLoading
}) => {
  const [competitionSlug, setCompetitionSlug] = useState('');
  const [searchText, setSearchText] = useState('');
  const [minRank, setMinRank] = useState('');
  const [maxRank, setMaxRank] = useState('');
  const [minScore, setMinScore] = useState('');
  const [maxScore, setMaxScore] = useState('');
  const [userId, setUserId] = useState('');
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const query: SolutionSearchQuery = {
      competitionSlug: competitionSlug || undefined,
      text: searchText || undefined,
      minRank: minRank ? parseInt(minRank, 10) : undefined,
      maxRank: maxRank ? parseInt(maxRank, 10) : undefined,
      minScore: minScore ? parseFloat(minScore) : undefined,
      maxScore: maxScore ? parseFloat(maxScore) : undefined,
      userId: userId || undefined
    };
    
    onSearch(query);
  };
  
  return (
    <div className="search-form">
      <h2>ソリューション検索</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="competitionSlug">コンペティションSlug:</label>
          <input
            type="text"
            id="competitionSlug"
            value={competitionSlug}
            onChange={(e) => setCompetitionSlug(e.target.value)}
            placeholder="例: titanic"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="searchText">検索テキスト:</label>
          <input
            type="text"
            id="searchText"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="ソリューションの概要で検索"
          />
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="minRank">最小順位:</label>
            <input
              type="number"
              id="minRank"
              value={minRank}
              onChange={(e) => setMinRank(e.target.value)}
              placeholder="例: 1"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="maxRank">最大順位:</label>
            <input
              type="number"
              id="maxRank"
              value={maxRank}
              onChange={(e) => setMaxRank(e.target.value)}
              placeholder="例: 10"
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="minScore">最小スコア:</label>
            <input
              type="number"
              id="minScore"
              value={minScore}
              onChange={(e) => setMinScore(e.target.value)}
              placeholder="例: 0.8"
              step="0.01"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="maxScore">最大スコア:</label>
            <input
              type="number"
              id="maxScore"
              value={maxScore}
              onChange={(e) => setMaxScore(e.target.value)}
              placeholder="例: 1.0"
              step="0.01"
            />
          </div>
        </div>
        
        <div className="form-group">
          <label htmlFor="userId">ユーザーID:</label>
          <input
            type="text"
            id="userId"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="例: user1"
          />
        </div>
        
        <button type="submit" disabled={isLoading}>
          {isLoading ? '検索中...' : '検索'}
        </button>
      </form>
    </div>
  );
};

export default SolutionSearchForm;
